<div #outer class="tabs-outer" [class.stretch]="stretch">
  <div class="tabs-track" [attr.role]="isRoutingMode ? null : 'tablist'">
    <!-- Sliding thumb: sized and moved from the component -->
    <span #thumb class="tabs-thumb" aria-hidden="true"></span>

    <!-- Routing mode: links -->
    @if (isRoutingMode) {
      @for (tab of tabs; track $index; let i = $index) {
        <a
          #tabEl
          class="tab-item"
          [class.active]="_activeIndex === i"
          [attr.aria-current]="_activeIndex === i ? 'page' : null"
          [routerLink]="tab.link"
          [queryParams]="tab.queryParams ?? null"
          (click)="tabChange.emit(i)"
        >
          @if (tab.icon) {
            <svg
              class="tab-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path [attr.d]="tab.icon" />
            </svg>
          }
          <span class="tab-label" [attr.data-label]="tab.title">{{ tab.title }}</span>
          @if (tab.count) {
            <span class="tab-count">{{ formatCount(tab.count) }}</span>
          }
        </a>
      }
    }

    <!-- View / click mode: tab buttons -->
    @if (!isRoutingMode) {
      @for (tab of tabs; track $index; let i = $index) {
        <button
          #tabEl
          type="button"
          role="tab"
          class="tab-item"
          [id]="tabId(i)"
          [class.active]="_activeIndex === i"
          [attr.aria-selected]="_activeIndex === i"
          [attr.aria-controls]="panelId || null"
          [attr.tabindex]="_activeIndex === i ? 0 : -1"
          (click)="selectTab(i)"
          (keydown)="onKeydown($event, i)"
        >
          @if (tab.icon) {
            <svg
              class="tab-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path [attr.d]="tab.icon" />
            </svg>
          }
          <span class="tab-label" [attr.data-label]="tab.title">{{ tab.title }}</span>
          @if (tab.count) {
            <span class="tab-count">{{ formatCount(tab.count) }}</span>
          }
        </button>
      }
    }
  </div>
</div>
